// extracted by mini-css-extract-plugin
module.exports = {"title":"style_title__2dgot","whiteTitle":"style_whiteTitle__2ssmb","underline":"style_underline__3CZPf","whiteUnderline":"style_whiteUnderline__Q29au"};